<template>
  <div class="bp-checkboxes-dropdown">
    <label class="fs-12 mb-2" v-if="label">
      {{ label }}
    </label>
    <b-dropdown no-caret block :disabled="disabled" @show="handleClick">
      <template #button-content>
        <div v-if="!selectedOptions.length">
          {{ placeholder }}
        </div>
        <div v-else class="content">
          <bp-tag
            v-for="(option, index) in selectedOptions"
            :key="index"
            :text="option.label"
            :disabled="disabled"
            chip
            @remove="remove(option.id)"
          />
        </div>
        <bp-icon icon="fa fa-angle-down" />
      </template>

      <div class="dropdown-content">
        <div v-if="!options.length" class="ml-3 fs-14 text-neutral-900">
          Nenhuma opção disponível
        </div>
        <template v-else>
          <bp-checkbox
            v-model="allSelected"
            id="allSelected"
            class="py-2"
            :size="size"
            :indeterminate="indeterminate"
            :name="`Selecionar ${masculine ? 'todos' : 'todas'}`"
            @change="selectAll"
          />
          <hr class="my-3 mx-2" />
          <bp-checkbox
            v-for="(option, index) in options"
            v-model="innerOptions[index].checked"
            :id="option.id"
            :key="index"
            class="py-2"
            :size="size"
            :name="option.label"
            @change="select"
          />
        </template>
      </div>
    </b-dropdown>
    <responsive-modal v-model="modal">
      <div class="text-neutral-900 mb-4 ml-2">Opções</div>
      <bp-checkbox
        v-model="allSelected"
        id="allSelected"
        class="py-2"
        :size="size"
        :indeterminate="indeterminate"
        :name="`Selecionar ${masculine ? 'todos' : 'todas'}`"
        @change="selectAll"
      />
      <hr class="my-3 mx-2" />
      <bp-checkbox
        v-for="(option, index) in options"
        v-model="innerOptions[index].checked"
        :id="option.id"
        :key="index"
        class="py-2"
        :size="size"
        :name="option.label"
        @change="select"
      />
    </responsive-modal>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: "Selecione as opções"
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    masculine: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: String,
      default: () => "lg",
      validator: value => ["lg", "sm"].includes(value)
    }
  },
  data() {
    const innerOptions = this.options.map(option => ({
      ...option,
      checked: this.value.includes(option.id) ? option.id : ""
    }));

    const allSelected =
      this.value.length === this.options.length ? "allSelected" : "";

    return {
      modal: false,
      innerOptions,
      allSelected
    };
  },
  computed: {
    selectedOptions() {
      return this.innerOptions.filter(option => option.checked);
    },
    indeterminate() {
      return !!(
        this.innerOptions.find(option => option.checked) &&
        this.innerOptions.find(option => !option.checked)
      );
    }
  },
  methods: {
    handleClick(event) {
      if (window.innerWidth > 768) return;
      event.preventDefault();
      this.modal = true;
    },
    remove(id) {
      this.innerOptions.find(option => option.id === id).checked = "";
      this.select();
    },
    select() {
      this.allSelected = this.innerOptions.find(option => option.checked)
        ? "allSelected"
        : "";
    },
    selectAll(v) {
      this.innerOptions = this.innerOptions.map(option => ({
        ...option,
        checked: v ? option.id : ""
      }));
    }
  },
  watch: {
    selectedOptions(v) {
      this.$emit(
        "input",
        v.map(option => option.id)
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.bp-checkboxes-dropdown {
  .content {
    display: flex;
    gap: 6px;
  }

  ::v-deep {
    .b-dropdown {
      .dropdown-menu {
        padding: 10px 8px !important;
      }
      .dropdown-toggle {
        font-size: 14px;
        min-height: 40px;
        padding: 8px 12px;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: normal;
        color: #5a5466;
        background-color: unset;
        border-color: #c4c0cc;
        i {
          transition: all 0.2s;
        }
        &:is(:hover, :active):not(:disabled) {
          border-color: #77788edd;
        }
        &:disabled {
          cursor: not-allowed;
          background-color: #f5f7fa;
          border-color: #c4c0cc;
          color: #c0c4cc;
        }
      }
      &.show {
        .dropdown-toggle {
          border-color: $primary-600 !important;
          cursor: default;
          .fa-angle-down {
            color: $primary-600;
            transform: rotate(180deg);
          }
        }
      }
      .dropdown-menu {
        width: 100%;
        max-width: 100%;
        max-height: 200px;
        overflow-y: scroll;
        scrollbar-width: thin;

        &::-webkit-scrollbar {
          background-color: #fff;
          border-radius: 0 4px 4px 0;
        }
        &::-webkit-scrollbar-thumb {
          height: 10px;
          border-radius: 10px;
          border: 5px solid white;
          background-color: #928f98;
        }

        padding: 8px 16px;
        border-radius: 4px;
        border: 1px solid rgba(219, 221, 230, 0.85);
        button {
          font-weight: 500;
        }
      }
      .btn-secondary:not(:disabled):not(.disabled):active:focus,
      .btn-secondary:not(:disabled):not(.disabled).active:focus,
      .show > .btn-secondary.dropdown-toggle:focus {
        box-shadow: none;
      }
    }
  }
}
</style>
